import {BaseSearchModel} from '../../core/base/base-search.model';

export class SavedSearchModel extends BaseSearchModel {
    searchModel: any;
    searchType: string;
    searchLabel: any;
}



// WEBPACK FOOTER //
// ./src/app/components/think-search-header/saved-search.model.ts